export function formatIDR(value) {
  if (typeof value !== "number") {
    value = Number(value) || 0;
  }
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value);
}
